import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  Checkbox as MaterialCheckbox,
  FormLabel,
} from "@mui/material";
import { CheckboxGroupProps } from "./types";

const CheckboxGroup = ({
  data,
  disabled,
  error,
  helperText,
  label,
  required,
  row,
  onChange,
}: CheckboxGroupProps) => {
  return (
    <FormControl disabled={disabled} error={error} required={required}>
      {label && <FormLabel id={`label-id-${label}`}>{label}</FormLabel>}
      <FormGroup aria-labelledby={`label-id-${label}`} row={row}>
        {data.map((item) => (
          <FormControlLabel
            key={item.value}
            label={item.label}
            className={`label-id-${item.value}`}
            control={
              <MaterialCheckbox
                name={item.value}
                checked={item.checked}
                disabled={item.disabled}
                onChange={onChange}
              />
            }
          />
        ))}
      </FormGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default CheckboxGroup;
